module.exports = __webpack_public_path__ + "img/image-24.5b7a1e24.webp";